import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useAppNavigate from "../../components/router/use-app-navigate";
import AuthContext from "../../components/auth-context";
import Form from "../../components/inputs/form";
import Textbox from "../../components/inputs/textbox";
import ChangeNumberForm from "../../types/change-number";
import ChangeNumberApi from "../../api/change-sim-card";
import { useState } from "react";

function ChangeNumber() {
  const { register, handleSubmit } = useForm<ChangeNumberForm>();
  const navigate = useAppNavigate();
  const { t } = useTranslation(undefined, { keyPrefix: "SignUp" });
  const context = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const { activeFileId } = context;
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = async (data: ChangeNumberForm): Promise<string> => {
    const { number, serial, imei } = data;
    setLoading(true);
    const { errorMessage } = await new ChangeNumberApi(context).post({
      fileId: activeFileId,
      number,
      serial,
      imei,
    });

    if (errorMessage) {
      setErrorMessage(errorMessage);
      setLoading(false);
      return errorMessage;
    }

    setLoading(false);
    navigate("/");
    return "success";
  };

  return (
    <div className="flex justify-center items-center py-10 px-4">
      <div className="w-full sm:w-[500px] md:w-[600px] lg:w-[700px] bg-white shadow-lg rounded-2xl p-6">
        {errorMessage && (
          <div className="text-red-500 text-right p-3 mb-4">{errorMessage}</div>
        )}
        <Form submit={onSubmit} handleSubmit={handleSubmit}>
          <h3 className="lead-title pt-2 text-center mb-6">
            {t("ChangeNumber")}
          </h3>

          <div className="space-y-4">
            <Textbox {...register("number")} label="شماره" />
            <Textbox {...register("serial")} label="سریال" />
            <Textbox {...register("imei")} label="IMEI" />
          </div>

          <div className="rule-section flex flex-col sm:flex-row justify-center sm:justify-between gap-4 mt-8">
            <button
              type="submit"
              disabled={loading}
              className={`signup-btn p-5 flex items-center justify-center gap-2 rounded-md ${
                loading
                  ? "opacity-50 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
              tabIndex={20}
            >
              تایید
              <span className="sepanta-icon-left-long-arrow ml-2"></span>
            </button>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="signup-btn px-6 py-3 flex justify-center items-center rounded-xl w-full sm:w-auto"
              tabIndex={20}
            >
              رد کردن
              <span className="sepanta-icon-left-long-arrow ml-2"></span>
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default ChangeNumber;
